export default __webpack_public_path__ + "static/media/progress.f6732c77.svg";